"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var OrderAddSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M10,15 L4.00496281,15 C3.45267806,15 3.00496281,14.5522847 3.00496281,14 C3.00496281,13.9667702 3.00661913,13.9335611 3.00992562,13.9004963 L4.00496281,5.90049628 C4.05608299,5.38929448 4.48624855,5 5,5 L6,5 L6,4 C6,2.8954305 7.11928813,2 8.5,2 C9.88071187,2 11,2.8954305 11,4 L11,5 L12,5 C12.5137514,5 12.943917,5.38929448 12.9950372,5.90049628 L13.3782612,8.98157928 L12.3722335,8.99272064 L12,6 L5,6 L4.00496281,14 L10,14 L10,15 Z M7,5 L10,5 L10,4 C10,3.5029303 9.37133713,3 8.5,3 C7.62866287,3 7,3.5029303 7,4 L7,5 Z M13,12 L13,10 L14,10 L14,12 L16,12 L16,13 L14,13 L14,15 L13,15 L13,13 L11,13 L11,12 L13,12 Z" })));
};
OrderAddSmall.displayName = 'OrderAddSmall';
exports.default = OrderAddSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=OrderAddSmall.js.map